import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { WeeklyResultByStoreReportService } from 'src/app/pages/common/reports/weekly-result-by-store-report/weekly-result-by-store-report.service';
import { ShopinfoService } from 'src/app/pages/common/system/shopinfo/shopinfo.service';
import { ShopinfoModel } from 'src/app/pages/common/system/shopinfo/model/shopinfo.model';
import { DepartmentService } from 'src/app/pages/common/system/department/department.service';
import { FormsModule } from '@angular/forms';
import moment from 'moment';
import { DayEndReportService } from './day-end-report.service';
import { UserInfoModel } from 'src/app/common/models/user-info.model';
import { AppConstants } from 'src/app/common/app.constants';
import { TerminalService } from 'src/app/pages/common/system/terminal/terminal.service';
import { AccessLogService } from 'src/app/pages/shop/reports/access-log/access-log.service';
import e from 'express';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-day-end-report',
  standalone: false,
  templateUrl: './day-end-report.component.html',
  styleUrl: './day-end-report.component.scss'
})
export class DayEndReportComponent {

  user: UserInfoModel | undefined;
  title: string = "Day End";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  // years: number[];
  selectedYear: any;
  weeks: any[] = [];
  cashierListData: any = [];
  terminalListData: any = [];
  cashierData: any = [];
  // In your component class
  financialYears: any[] = []; // This will store the finYears array from API
  years: number[] = []; // This will store just the year numbers if needed separately
  permission: any;




  curFinYear!: string; // Add this to your component properties  
  daysOfWeek: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  hours: string[] = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  fromHour: string = '00';
  toHour: string = '00';
  shop_id: any;
  shop_name: any;
  terminalValidationMessage: any;
  cashierValidationMessage: any;
  terminalSelectionInvalid: boolean = false;
  cashierSelectionInvalid: boolean = false;
  isExpandedTerminal = false;
  isExpandedCashier = false;
  resetButtonEnabled: boolean = false;
  showSelectedTerminalOnly = false;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private dayEndReportService: DayEndReportService,
    private snackBarService: SnackBarService,
    private ShopinfoService: ShopinfoService,
    private terminalService: TerminalService,
    private cashierService: AccessLogService,
    public dialog: MatDialog, private permissionService: PermissionService) {


    const today= new Date();
    this.editForm = this.builder.group({
      // year: this.builder.control( ''),
      period_from: this.builder.control(today, Validators.required),
      shift_from: this.builder.control(5),
      terminalFilter: [''],
    });

    this.currentYear = new Date().getFullYear();
    // this.years = this.generateYears();

    // Automatically save to sessionStorage when form values change
    this.editForm.valueChanges.subscribe(() => {
      this.saveToSessionStorage(null);
    });
    this.permission = this.permissionService.getPagePermission("day-end-report");
    // Load saved data if it exists
    // this.loadFromSessionStorage();
    // Set all days as checked by default
    // const daysGroup = this.editForm.get('days') as FormGroup;
    // this.daysOfWeek.forEach(day => {
    //   daysGroup.addControl(day, new FormControl(true)); // ✅ checked by default
    // });

  }

  ngOnInit(): void {
    // this.loadData();
    this.terminalList();
    let sesUser = sessionStorage.getItem(AppConstants.SESSION_VAR_USER);
    this.user = (sesUser !== null) ? JSON.parse(sesUser) : undefined;
    console.log(this.user)

  }

  toggleContent(divData: string): void {
    if (divData == "terminal") {
      this.isExpandedTerminal = !this.isExpandedTerminal;
    }
    if (divData == "cashier") {
      this.isExpandedCashier = !this.isExpandedCashier;
    }
  }
  // Select All and Reset for terminal
  selectAll(list: any[]) {
    list.forEach(item => item.selected = true);
  }

  // Custom validator function
  hourRangeValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const from = group.get('fromHour')?.value;
      const to = group.get('toHour')?.value;

      if (from != null && to != null && from > to) {
        return { invalidHourRange: true };
      }
      return null;
    };
  }
  // getCurrentWeek(weeks: any[]): any {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0); // Normalize time to midnight for accurate comparison

  //   return weeks.find(week => {
  //     const startDate = new Date(week.start_date);
  //     const endDate = new Date(week.end_date);
  //     return today >= startDate && today <= endDate;
  //   });
  // }
  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }


  sortOptions = [
    { value: 'shop_name', label: 'Shop Name' },
    { value: 'this_year_this_week_sales', label: 'This Year Sales' },
    { value: 'last_year_this_week_sales', label: 'Last Year Sales' },
    { value: 'this_week_cust_orders', label: 'This Year Customer Orders' },
    { value: 'last_year_cus_order', label: 'Last Year Customer Orders' },
    { value: 'this_week_labour_cost', label: 'This Year Labour Cost' },
    { value: 'last_year_this_week_labour_cost', label: 'Last Year Labour Cost' },
  ];

  sortOrderOptions = [
    { value: 'asc', label: 'Ascending' },
    { value: 'desc', label: 'Descending' }
  ];

  saveToSessionStorage(selectionData: any): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    if (selectionData == "terminal") {
      const selectedTerminalIds = this.terminalListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.code);

      // If no shops are selected, we treat it as "ALL" (empty array means all shops)
      const terminalIds = selectedTerminalIds.length > 0 ? selectedTerminalIds : [];
      if (selectedTerminalIds.length > 0) {
        this.resetButtonEnabled = true;
      } else {
        this.resetButtonEnabled = false;
      }


      // if (terminalIds.length === 0) {
      //   this.terminalSelectionInvalid = true;
      //   return;
      // } else {
      //   this.terminalSelectionInvalid = false; // ✅ clear message when valid
      // }

      // Create the data object
      const reportData = {
        year: this.editForm.get('year')?.value,
        weekNo: this.editForm.get('week_no')?.value,
        shopId: terminalIds,
        sortBy: this.editForm.get('sort_by')?.value,
        sortDir: this.editForm.get('sort_order')?.value,
        isExport: 0
      };

      // Save to sessionStorage
      sessionStorage.setItem('dayEndReportData', JSON.stringify(reportData));
    }

  }

  loadFromSessionStorage(): void {
    const savedData = sessionStorage.getItem('weeklyStoreReportData');
    // console.log(savedData)
    if (savedData) {
      const reportData = JSON.parse(savedData);

      // Set form values
      this.editForm.patchValue({
        year: reportData.year,
        week_no: reportData.weekNo,
        sort_by: reportData.sortBy,
        sort_order: reportData.sortDir
      }, { emitEvent: false }); // Prevent infinite loop

      // Set shop selections (if shop IDs were saved)
      if (reportData.shopId && reportData.shopId.length > 0) {
        this.cashierListData.forEach((shop: any) => {
          shop.selected = reportData.shopId.includes(shop.item.id);
        });
      } else {
        // If no shops were selected before, reset all to false (treat as "ALL")
        this.cashierListData.forEach((shop: any) => shop.selected = false);
      }

      // Manually trigger year change if needed
      if (reportData.year) {
        this.onYearChange();
      }
    }
  }




  onYearChange(): void {
    this.selectedYear = this.editForm.get('year')?.value;
    console.log('Selected Year:', this.selectedYear);

    // Find the selected financial year from financialYears array
    const selectedFinYear = this.financialYears.find(fy => fy.year === this.selectedYear);

    if (selectedFinYear) {
      // Map the weeks to the format needed for the dropdown
      this.weeks = selectedFinYear.weeks.map((week: any) => ({
        ...week,
        displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
      }));

      // Set the first week as default if weeks exist
      if (this.weeks.length > 0) {
        this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get('week_no')?.setValue(null);
    }
  }





  // loadData(): void {
  //   // console.log('Selected Year:', this.selectedYear);

  //   this.hourlySalesReportService.getWeekNoList().subscribe(response => {
  //     // console.log('API Response:', response);

  //     if (response.status === 'SUCCESS') {
  //       this.financialYears = response.data.finYears;
  //       this.years = this.financialYears.map(fy => fy.year);

  //       // Only set the default value if the form control is empty
  //       if (!this.editForm.get('year')?.value) {
  //         this.curFinYear = response.data.curFinYear;
  //         if (this.curFinYear) {
  //           const yearValue = parseInt(this.curFinYear);
  //           this.editForm.get('year')?.setValue(yearValue, { emitEvent: false });

  //           // Set weeks for the current financial year
  //           const currentFinYear = this.financialYears.find(fy => fy.year === yearValue);
  //           if (currentFinYear) {
  //             this.weeks = currentFinYear.weeks.map((week: any) => ({
  //               ...week,
  //               displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
  //             }));
  //             // Set the current week as default
  //             const currentWeek = this.getCurrentWeek(this.weeks);
  //             if (currentWeek) {
  //               this.editForm.get('week_no')?.setValue(currentWeek.week_no);
  //             } else if (this.weeks.length > 0) {
  //               // Fallback to first week if current week not found
  //               this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
  //             }
  //           }
  //         }
  //       }

  //       // console.log('Financial Years Data:', this.financialYears);
  //     } else {
  //       console.error('API Error:', response.message);
  //     }
  //   });
  // }
  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }



  terminalList(): void {

    let requestData = {
      search: {

        filters: {
          simpleSearch: [],
          advSearch: [
            {
              column: "is_system",
              operator: "=",
              value: 0
            }
          ],
          scope: {
            limit: 10000,
            offset: 0
          }
        },
        sort: [
          {
            column: "name",
            order: "asc"
          }
        ]

      }
    }

    this.dayEndReportService.getTerminalList(requestData).subscribe({
      next: (response: any) => {
        this.terminalListData = [];
        let index = 0;
        response.data.terminals.forEach((item: any) => {
          const data = { index: index, item: item, selected: false };
          this.terminalListData.push(data);
          index++;
        });
      },
      error: (error: any) => {
        // Handle error here
        console.error('Error fetching terminal list:', error);
      }
    });
  }


  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach(el => {
      if (el.selected) {
        count++;
      }
    })
    return sourceList.length + '/' + ((count > 0) ? (count) : 'ALL');
  }

  // Filtered getters for terminal
  get filteredTerminalListData() {
    let filteredList = this.terminalListData;
    if (this.showSelectedTerminalOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('terminalFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  toggleSelectAllTerminal() {
    const allSelected = this.terminalListData.every((item: any) => item.selected);
    this.terminalListData.forEach((item: any) => (item.selected = !allSelected));
    this.updateResetButtonState();
  }

  getSelectAllIconTerminal(): string {
    const allSelected = this.terminalListData.every((item: any) => item.selected);
    const someSelected = this.terminalListData.some((item: any) => item.selected);

    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  updateResetButtonState() {
    this.resetButtonEnabled = this.selectedTerminalSourcesCount > 0;
  }

  reset(sourceList: any[]) {
    sourceList.forEach(el => {
      el.selected = false;
    });
    this.updateResetButtonState();
  }

  // Selected count for terminal
  get selectedTerminalSourcesCount(): number {
    return this.terminalListData?.filter((item: any) => item.selected)?.length || 0;
  }

  onListSelectionChange(selectionData: any): void {
    this.saveToSessionStorage(selectionData);
  }

  navigateToWeeklyReport() {
    this.router.navigate(['/weekly-result-store-report-view']);
    // or with parameters if needed:
    // this.router.navigate(['/weekly-result-store-report-view', {param: value}]);
  }

  exportClicked(): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    // if (this.editForm.invalid) {
    //   this.editForm.markAllAsTouched(); // This will trigger error messages
    //   return;
    // }
    if (this.editForm.valid) {
      const selectedTerminalIds = this.terminalListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.code);
      // Check: At least one department selected
      // if (selectedTerminalIds.length === 0) {
      //   this.terminalSelectionInvalid = true;
      //   this.terminalValidationMessage = 'Please select at least one terminal.';
      //   return;
      // } else {
      //   this.terminalSelectionInvalid = false; // ✅ clear message when valid
      // }
      //  // Check: At least one department selected
      //  if (selectedCashierIds.length === 0) {
      //   this.cashierSelectionInvalid = true;
      //   this.cashierValidationMessage = 'Please select at least one cashier.';
      //   return;
      // } else {
      //   this.cashierSelectionInvalid = false; // ✅ clear message when valid
      // }
      // If no shops are selected, we treat it as "ALL" (empty array means all shops)
      const terminalIds = selectedTerminalIds.length > 0 ? selectedTerminalIds : [];
      var rawDateFrom = this.editForm.get('period_from')?.value;
      var formattedDateFrom = moment(rawDateFrom).format('DD-MM-YYYY');
      // var days = this.selectedDays();
      // Create the data object
      if (this.user?.shop_info !== null && this.user?.shop_info !== undefined) {
        this.shop_id = this.user?.shop_info.id;
        this.shop_name = this.user?.shop_info.name;
      }
      const reportData = {
        shopId: this.shop_id,
        shopName: this.shop_name,
        dateFrom: formattedDateFrom,
        shiftFrom: this.editForm.get('shift_from')?.value,
        terminalId: terminalIds,
        isExport: 1
      };
      this.IsDownloading = true;
      if (reportData) {
        this.dayEndReportService.exportDailySalesReport(reportData).subscribe({
          next: (response) => {
            // Handle "No data found" response
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const text = reader.result as string;
                const json = JSON.parse(text);
                if (json.status === 'NO_DATA_FOUND') {
                  let snackBarData: SnackBarData = {
                    message: 'No data found.',
                    title: 'No Data!!!',
                    type: 'warn'
                  }
                  this.IsDownloading = false;
                  this.snackBarService.openSnackBar(snackBarData);
                  return;
                }
              } catch (e) {
                // Not JSON, treat as file
                const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'day-end-report.xlsx';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                this.IsDownloading = false;
                return;
              }
              // If JSON but not NO_DATA_FOUND, treat as error
              this.IsDownloading = false;
            };
            reader.readAsText(response);
          },
          error: (error) => {
            // ...existing code...
            this.IsDownloading = false;
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    } else {
      this.editForm.markAllAsTouched();
    }
  }

}
